import React, { useEffect, useState } from 'react';
import Page from './page.js';
import _ from 'lodash';
import Top from './top.js';
import Bottom from './bottom.js';
import { useRecoilState, useRecoilValue } from 'recoil';
import { isChildOpenAtom, isFolderOpenAtom, isFrostyAtom, openAppAtom } from '../recoil/isChildOpenAtom';



import {
  motion,
  //useMotionValue
} from "framer-motion";
import PageBubbles from './PageBubbles';
import FullScreen from './FullScreen';
import './base.css';




const Base = () => {

  console.log('Base render');

  

  //const [isFullScreenVisible, setIsFullScreenVisible] = useState(false);
  const [isChildOpen, setIsChildOpen] = useRecoilState(isChildOpenAtom);
  const isFolderOpen = useRecoilValue(isFolderOpenAtom);
  //const [openApp, setOpenApp] = useRecoilState(openAppAtom);
  //const [isFrosty, setIsFrosty] = useRecoilState(isFrostyAtom);

  

  /** isFullScreenVisible toggle */
  // useEffect(() => {
  //   let timeout;
  //   if (isChildOpen) {
  //     // open
  //     setIsFullScreenVisible(true);
  //   } else {
  //     // close
  //     timeout = setTimeout(() => {
  //       setIsFullScreenVisible(false);
  //     }, animateSpeedSeconds * 1000);
  //   }
  //   return () => {
  //     if (timeout) { clearTimeout(timeout); }
  //   };
  // }, [isChildOpen]);

  //console.log('render() activePage', activePage);

  //const y = useMotionValue(0);
  //const zIndex = useMotionValue(isChildOpen ? 20 : 0);
  //const inverted = useInvertedScale();

  // function onStart() {
  //   console.log("Animation started")
  // }
  // function onComplete() {
  //   console.log("Animation completed")
  // }

  

  return (
    <div className="base-wrap">

      <FullScreen />

      <div
        className={(isChildOpen && !isFolderOpen) ? 'frosty selected' : 'frosty'}
      />

      <Top />

      <div className="base">
        <div className="scrollx">

          <Page pagenumber={1}  />
          <Page pagenumber={2}  />
          <Page pagenumber={3}  />

          <PageBubbles />

          <Bottom isChildOpen={isChildOpen} />
        </div>
      </div>
      
    </div>
  );
  //}
};

export default Base
